import { BASE_FONTS } from '@/components/Recipe/FlowComponents/Editor/Designer/LayerPropertyPanel/FontsList';

const BASE_FONT_VALUES: readonly string[] = Array.from(new Set(BASE_FONTS.map((f) => f.value))).map(String);

/**
 * Filenames that start with a base built-in font name but are not static base fonts.
 */
const BASE_FONT_PREFIX_EXCEPTIONS: readonly string[] = ['BebasNeue-Bold'];

const BASE_FONT_PREFIXES: readonly string[] = [...BASE_FONT_VALUES].sort((a, b) => b.length - a.length);

/**
 * True when `resourceKey` should load from `/fonts/` (matches a BASE_FONTS built-in filename prefix).
 * Longest prefix wins so e.g. `InterTight-…` matches before `Inter`. Other keys use workspace font URLs from the graph loader.
 */
export function isBaseFont(resourceKey: string): boolean {
  for (const ex of BASE_FONT_PREFIX_EXCEPTIONS) {
    if (resourceKey.startsWith(ex)) {
      return false;
    }
  }
  for (const prefix of BASE_FONT_PREFIXES) {
    if (resourceKey.startsWith(prefix)) {
      return true;
    }
  }
  return false;
}

/**
 * Resolves the fetch URL for a font resource key using static `/fonts/` or the workspace font list.
 */
export function resolveFontFileUrl(
  resourceKey: string,
  workspaceCustomFontsUrlsMap: ReadonlyMap<string, string>,
): string {
  if (isBaseFont(resourceKey) || !workspaceCustomFontsUrlsMap.has(resourceKey)) {
    return '/fonts/' + resourceKey;
  }
  // This is a temporary way to load the font by the legacy font file name.
  // In the next phase of custom-fonts implementation, we'll load the font according to its family, weight and style
  const url = workspaceCustomFontsUrlsMap.get(resourceKey);
  if (!url) {
    throw new Error(`Font file not found for key "${resourceKey}" in the workspace font list`);
  }
  return url;
}
